import { useContext } from 'react';

import { AccountContext } from '@/contexts';

export const useAccount = () => {
	const accountContext = useContext(AccountContext);
	return accountContext;
};
